import { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function NoticeModal() {

  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);

  const [cookies, setCookie ] = useCookies(['cookie-note']);

    useEffect(() => {

      if (!cookies['cookie-note']) {
        setCookie('cookie-note', 'true');    
      } else {
        setShow(false);
      }      

    }, []);
   
  return (
    <>
      <Modal size="lg" scrollable={true} show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>IMPORTANT Note :: </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div class="modal-body code">
              <h2>We are NOT :-</h2>
              <ul>
                <li>SUPERVISOR,</li>
                <li>THEKEDAR,</li>             
                <li>NOT LIABLE FOR ANY DELAYS OR ISSUES ARISE FROM THIRD PARTY DURING / AFTER THE WORK START / PROCESS.</li>
                <li>NOT RESPONSIBLE FOR ANY DAMAGE TO PROPERTY OR THIRD PARTY OR PERSONNEL DURING THE WORK PROCESS.</li>                    
                <li>NOT RESPONSIBLE FOR THE FINISHING OF WORK,</li>                               
                <li>NOT RESPONSIBLE FOR THE COMPLETION OF WORK.</li>
              </ul>
                <code>WE PROVIDE MEN ON HOURLY BASIS MINIMUM 2 Hrs, MAX 8 Hrs & OVERTIME.</code><br></br>
                <code>YOUR WORK - YOUR SUPERVISION - YOUR RESPONSIBILITY.</code>
              <h2>We are :-</h2>
              <ul>
                <li>PEOPLE PROVIDER</li>
                <li>HELPER, LABOUR, WORKER, MEN POWER PROVIDER</li>                
              </ul>
              <code>WE ASK CUSTOMER TO VERIFY IF ALL WORKER'S ARE RIGHT FIT FOR THE WORK WITHIN 30 MIN AFTER THE WORK START</code>
            </div>            
            <h3>With Upfront Token Amount, We work on Priority.&nbsp;</h3>
          </Modal.Body>
        <Modal.Footer>          
          
          
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default NoticeModal;